var Handlebars = require("handlebars/runtime");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"modal-detail-el detail-page-wrapper\" data-readonly-detailpage=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"readOnlyForm") || (depth0 != null ? lookupProperty(depth0,"readOnlyForm") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"readOnlyForm","hash":{},"data":data,"loc":{"start":{"line":1,"column":75},"end":{"line":1,"column":91}}}) : helper)))
    + "\">\n	<div class=\"modal-detail-page\"></div>\n</div>\n";
},"useData":true});